import { Skeleton } from 'antd/lib'
import './index.less'

export default Skeleton



// WEBPACK FOOTER //
// ./src/elements/skeleton/index.js